import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {tap} from 'rxjs/operators';
import {Store} from "@ngrx/store";
import {RestUrlsConfig} from "@signature-it/ngx-generic/config";
import {DriveTypeEnum} from "@signature-it/ngx-generic/enums";
import { saveAs } from 'file-saver';

@Injectable({
    providedIn: 'root'
})
export class AssetsLibraryService {

    protected type: DriveTypeEnum;

    protected getTaxonomyUrl = `get-taxonomy`;
    protected getFileDataUrl = `files`;

    protected addNewDirectoryUrl = `new-directory`;
    protected deleteDirectoryUrl = `delete-directory`;
    protected updateDirectoryUrl = `update-directory`;
    protected downloadNodeUrl = `download-node`;

    protected updateFileUrl = `update-file`;
    protected deleteFileUrl = `delete-file`;
    protected downloadFileUrl = `download-file`;

    protected getAssetsLibraryVarUrl = `get-assets-library-var`;
    protected createAssetsLibraryUrl = `create-assets-library`;

    constructor(protected http: HttpClient,
                protected store$: Store<any>,
                protected restUrlsConf: RestUrlsConfig) {
    }

    setType(type: DriveTypeEnum) {
        this.type = type;
    }

    getRoute(url) {
        return `${this.restUrlsConf.appURL}/assets-library/${this.type}/${url}`;
    }


    getTaxonomy(taxonomyVar: string): Observable<[]> {
        return this.http.post<[]>(this.getRoute(this.getTaxonomyUrl), JSON.stringify({entity_type_var: taxonomyVar}))
            .pipe(tap((res) => {
                res;
            }, (error: any) => throwError(error)));
    }

    getData(nodeVar: string): Observable<[]> {

        return this.http.post<[]>(this.getRoute(this.getFileDataUrl), JSON.stringify({node_var: nodeVar}))
            .pipe(tap((res) => {
                res;
            }, (error: any) => throwError(error)));
    }

    newDirectory(directoryName, taxonomyTypeVar, parentVar) {
        return this.http.post<[]>(this.getRoute(this.addNewDirectoryUrl), JSON.stringify({
            node_name: directoryName,
            taxonomy_type_var: taxonomyTypeVar,
            parent_var: parentVar,
        })).pipe(tap((res) => {
            res;
        }, (error: any) => throwError(error)));
    }

    deleteDirectory(taxonomyTypeVar, nodeVar) {
        return this.http.post<[]>(this.getRoute(this.deleteDirectoryUrl), JSON.stringify({
            taxonomy_type_var: taxonomyTypeVar,
            node_var: nodeVar,
        })).pipe(tap((res) => {
            res;
        }, (error: any) => throwError(error)));
    }

    updateDirectory(nodeVar, nodeTitle) {
        return this.http.post<[]>(this.getRoute(this.updateDirectoryUrl), JSON.stringify({
            node_title: nodeTitle,
            node_var: nodeVar,
        })).pipe(tap((res) => {
            res;
        }, (error: any) => throwError(error)));
    }

    updateFile(id, title) {
        return this.http.post<[]>(this.getRoute(this.updateFileUrl), JSON.stringify({
            id: id,
            title: title,
        })).pipe(tap((res) => {
            res;
        }, (error: any) => throwError(error)));
    }

    getAssetsLibraryVar(productId) {
        return this.http.post<string>(this.getRoute(this.getAssetsLibraryVarUrl), JSON.stringify({
            id: productId,
        })).pipe(tap((res) => {
            res;
        }, (error: any) => throwError(error)));
    }

    createAssetsLibrary(productId, rootName) {
        return this.http.post<string>(this.getRoute(this.createAssetsLibraryUrl), JSON.stringify({
            id: productId,
            root_name: rootName,
            type: 'asset_library'
        })).pipe(tap((res) => {
            res;
        }, (error: any) => throwError(error)));
    }

    deleteFile(mediaId) {
        return this.http.post<string>(this.getRoute(this.deleteFileUrl), JSON.stringify({
            id: mediaId,
        })).pipe(tap((res) => {
            res;
        }, (error: any) => throwError(error)));
    }

    downloadFile(mediaId, fileName, openInNewTab) {
        this.downloadFileByPost(this.getRoute(this.downloadFileUrl), {id: mediaId}, fileName, openInNewTab)
    }

    downloadNode(nodeVar, name) {
        this.downloadFileByPost(this.getRoute(this.downloadNodeUrl), {node_var: nodeVar}, `${name}.zip`)
    }

    downloadFileByPost(url, params, fileName, openInNewTab = false) {
        this.http.post(url, JSON.stringify(params), { responseType: 'blob' }).subscribe((response: Blob) => {
            if(openInNewTab) {
                const blob = new Blob([response], { type: response.type });
                const objectUrl = URL.createObjectURL(blob);
                const newTab = window.open(objectUrl, '_blank');

                if (newTab) {
                    newTab.onload = () => {
                        URL.revokeObjectURL(objectUrl);
                    };
                } else {
                    console.error('Error In Open Tab');
                }
            } else {
                saveAs(response, fileName);
            }
        });
    }
}
